import { IconCircleCheck } from '@tabler/icons-react'
import clsx from 'clsx'

import { addTestId } from 'shared/utils/tests'

import {
  CustomerAddress,
  CustomerInvoiceAddress
} from '../submodules/addresses/types'
import { isCompanyInvoiceAddress } from '../submodules/addresses/utils'

import styles from './ProfileAddressSingleItemDetails.module.scss'

interface ProfileAddressSingleItemDetailsProps {
  address: CustomerAddress | CustomerInvoiceAddress
}

const ProfileAddressSingleItemDetails = ({
  address
}: ProfileAddressSingleItemDetailsProps) => {
  const isInvoiceTypeCompany = isCompanyInvoiceAddress(address)

  return (
    <div className={styles.details}>
      {isInvoiceTypeCompany ? (
        <>
          <div className={styles.column}>
            <h4 className={styles.title}>Nazwa firmy:</h4>
            <p className={styles.content}>
              {'companyName' in address ? address.companyName : ''}
            </p>
          </div>
          <div className={styles.column}>
            <h4 className={styles.title}>NIP:</h4>
            <p className={styles.content}>{'nip' in address ? address.nip : ''}</p>
          </div>
        </>
      ) : (
        <>
          <div className={styles.column}>
            <h4 className={styles.title}>Imię:</h4>
            <p className={styles.content}>{address.firstName}</p>
          </div>
          <div className={styles.column}>
            <h4 className={styles.title}>Nazwisko:</h4>
            <p className={styles.content}>{address.lastName}</p>
          </div>
        </>
      )}
      <div className={styles.column}>
        <h4 className={styles.title}>Adres:</h4>
        <p className={styles.content}>
          {address.street} {address.houseNumber}
          {address.flatNumber ? `/${address.flatNumber}` : ''}
          {', '}
          <span className={styles.tabletAndWebContent}>
            <br />
          </span>
          <span className={styles.noWrap}>
            {address.postalCode} {address.city}
          </span>
        </p>
      </div>

      <div className={clsx(styles.column, styles.columnIsDefault)}>
        {address.isDefault ? (
          <>
            <div
              className={styles.defaultInfoTagMobile}
              id='profile_address_default'
              {...addTestId('default-info-tag-mobile')}
            >
              <IconCircleCheck />
              Główny
            </div>

            <div
              className={styles.defaultInfoTagWeb}
              {...addTestId('default-info-tag')}
            >
              <IconCircleCheck />
              Główny
            </div>
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default ProfileAddressSingleItemDetails
